import { connectivityService } from '~/data/connectivity/ConnectivityService';
import { serviceLocal } from '~/data/local';
import { serviceRemote } from '~/data/remote';
import { ServiceCheck, ServiceDetails } from '~/types';
import store from '~/store';

export class ServiceRepository {
  async getService(id: ServiceDetails['id']): Promise<ServiceDetails | undefined> {
    if (connectivityService.isOnline()) {
      const data = await serviceRemote.fetchService(id);
      if (store.getState().machines.isOfflineAvailable(data.machineId)) {
        serviceLocal.updateServiceDetail(data);
      }
      return data;
    }
    return serviceLocal.getService(id);
  }

  async fetchAndCacheFavoriteServices(scope: string): Promise<ServiceDetails[]> {
    if (!connectivityService.isOnline()) {
      return [];
    }
    const data = await serviceRemote.fetchFavoriteServices(scope);
    await serviceLocal.reset(data);
    return data;
  }

  async writeThroughCache(service: ServiceDetails): Promise<void> {
    if (store.getState().machines.isOfflineAvailable(service.machineId)) {
      serviceLocal.updateServiceDetail(service);
    }
  }

  async getChecklist(
    payload: {
      serviceId: ServiceDetails['id'];
      serviceIntervalId: ServiceDetails['serviceIntervalId'];
    },
    cachedService?: ServiceDetails
  ): Promise<ServiceCheck[]> {
    if (connectivityService.isOnline()) {
      const checks = await serviceRemote.fetchChecklist(payload);
      if (
        cachedService &&
        String(cachedService.id) === String(payload.serviceId) &&
        store.getState().machines.isOfflineAvailable(cachedService.machineId)
      ) {
        serviceLocal.updateServiceDetail({ ...cachedService, checklist: checks });
      }
      return checks;
    }
    if (cachedService && String(cachedService.id) === String(payload.serviceId)) {
      return cachedService.checklist ?? [];
    }
    const local = await serviceLocal.getService(payload.serviceId);
    return local?.checklist ?? [];
  }
}

export const serviceRepository = new ServiceRepository();
